import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { SharedModule } from '../../../shared/shared.module';
import { LangSelectorComponent } from './lang-selector.component';

@NgModule({
  declarations: [LangSelectorComponent],
  imports: [SharedModule, MatDividerModule, MatIconModule, MatButtonModule],
  exports: [LangSelectorComponent],
})
export class LangSelectorModule {}
